export enum IndicatorIds {
  DYNAMIC = 1,
  STATIC = 26,
}
